var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8346 8.33398H15.0013V5.83398C15.0013 3.08398 12.7513 0.833984 10.0013 0.833984C7.2513 0.833984 5.0013 3.08398 5.0013 5.83398V8.33398H4.16797C2.7513 8.33398 1.66797 9.41732 1.66797 10.834V16.6673C1.66797 18.084 2.7513 19.1673 4.16797 19.1673H15.8346C17.2513 19.1673 18.3346 18.084 18.3346 16.6673V10.834C18.3346 9.41732 17.2513 8.33398 15.8346 8.33398ZM6.66797 5.83398C6.66797 4.00065 8.16797 2.50065 10.0013 2.50065C11.8346 2.50065 13.3346 4.00065 13.3346 5.83398V8.33398H6.66797V5.83398ZM15.8346 17.5007C16.3346 17.5007 16.668 17.1673 16.668 16.6673V10.834C16.668 10.334 16.3346 10.0007 15.8346 10.0007H4.16797C3.66797 10.0007 3.33464 10.334 3.33464 10.834V16.6673C3.33464 17.1673 3.66797 17.5007 4.16797 17.5007H15.8346Z",
    fill: "#3E556D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5578_2541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 18,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8346 8.33398H15.0013V5.83398C15.0013 3.08398 12.7513 0.833984 10.0013 0.833984C7.2513 0.833984 5.0013 3.08398 5.0013 5.83398V8.33398H4.16797C2.7513 8.33398 1.66797 9.41732 1.66797 10.834V16.6673C1.66797 18.084 2.7513 19.1673 4.16797 19.1673H15.8346C17.2513 19.1673 18.3346 18.084 18.3346 16.6673V10.834C18.3346 9.41732 17.2513 8.33398 15.8346 8.33398ZM6.66797 5.83398C6.66797 4.00065 8.16797 2.50065 10.0013 2.50065C11.8346 2.50065 13.3346 4.00065 13.3346 5.83398V8.33398H6.66797V5.83398ZM15.8346 17.5007C16.3346 17.5007 16.668 17.1673 16.668 16.6673V10.834C16.668 10.334 16.3346 10.0007 15.8346 10.0007H4.16797C3.66797 10.0007 3.33464 10.334 3.33464 10.834V16.6673C3.33464 17.1673 3.66797 17.5007 4.16797 17.5007H15.8346Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5578_2541)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V20H0V0Z",
    fill: "#3E556D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.61d78f2caf7ab0569cddc5d9c81e2102.svg";
export { ForwardRef as ReactComponent };